import { bind, classNames, Component, h, tag } from "omi";

import { tailwind } from "@/tailwind";

interface Props {
  /**
   * Whether the toggle is checked/active
   */
  checked: boolean;
  /**
   * Callback function when toggle state changes
   */
  onChange: (checked: boolean) => void;
}

/**
 * A reusable toggle switch component
 */
@tag("nw-toggle")
export class NWToggle extends Component<Props> {
  static css = [tailwind, ":host { height: 24px; }"];

  @bind
  private handleClick() {
    this.props.onChange(!this.props.checked);
  }

  render() {
    const { checked } = this.props;

    return (
      <button
        type="button"
        className={classNames(
          "relative inline-flex items-center h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-graywarm-500 focus:ring-offset-2",
          {
            "bg-black border-black": checked,
            "border-graysecondary-200 bg-graysecondary-200": !checked,
          },
        )}
        role="switch"
        aria-checked={checked}
        onClick={this.handleClick}
      >
        <span
          aria-hidden="true"
          className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
            checked ? "translate-x-5" : "translate-x-0"
          }`}
        />
      </button>
    );
  }
}
